import React, { useEffect, useState } from 'react'
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import AccountCircle from '@mui/icons-material/AccountCircle';
import Menu from '@mui/material/Menu';
import { Breadcrumbs, Button, Tooltip, useTheme } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import ProfileCard from './ProfileCard';
import ViewSidebarTwoToneIcon from '@mui/icons-material/ViewSidebarTwoTone';
import { getOpenRightSide, setOpenRightSide } from '../redux/openRightSideSlice';
import { getRegulatoryFile } from '../redux/regulatoryFileSlice';
import { getDpesRedux } from '../redux/dpesSlice';
import { getOpenPreviewDRG, setOpenPreviewDRG } from '../redux/openPreviewDRGSlice';
import { getOpenSimulatorDRG, setOpenSimulatorDRG } from '../redux/openSimulatorDRGSlice';
import { alpha } from "@mui/material";
import RocketTwoToneIcon from '@mui/icons-material/RocketTwoTone';
import PreviewTwoToneIcon from '@mui/icons-material/PreviewTwoTone';
import { getHasDiagramChange, setHasDiagramChange } from '../redux/hasDiagramChangeSlice';
import { current } from '@reduxjs/toolkit';
import { getOpenSimulatorPolicy, setOpenSimulatorPolicy } from '../redux/openSimulatorPolicySlice';

function WorkspaceToolBar() {

    const theme = useTheme();
    const drawerWidth = 300;
    const dispatch = useDispatch();
    const location = useLocation();
    const currentPage = location.pathname.split('/')[2];
    const [anchorEl, setAnchorEl] = useState(null);
    const regulatoryFile = useSelector(getRegulatoryFile);
    const openRightSide = useSelector(getOpenRightSide);
    const [rightSide, setRightSide] = useState(false);
    const [project, setProject] = useState();
    const [currentFileName, setCurrentFileName] = useState();
    const dpes = useSelector(getDpesRedux);
    const openPreviewDRG = useSelector(getOpenPreviewDRG);
    const openSimulatorDRG = useSelector(getOpenSimulatorDRG);
    const openSimulatorPolicy = useSelector(getOpenSimulatorPolicy);

    const [currentFile, setCurrentFile] = useState(null);

    const [policyFile, setPolicyFile] = useState(null);
    // const [validDiagram, setValidDiagram] = useState(false);

    // const hasDiagramChange = useSelector(getHasDiagramChange);

    useEffect(() => {
        const project = JSON.parse(localStorage.getItem('project'));
        if (project) {
            setProject(project);
        }
    }, []);

    const handleMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const onClickSimulatorIcon = () => {
        if (currentPage === 'regulatory') {
            dispatch(setOpenSimulatorDRG(true));
        } else if (currentPage === 'policy') {
            dispatch(setOpenSimulatorPolicy(true));
        }
    }

    const onClickOpenRightSide = () => {
        dispatch(setOpenRightSide(!openRightSide));
    };

    // const handleRouteChange = (newPath) => {
    //     console.log("handleRouteChange", newPath);
    //     console.log("hasDiagramChange: ", hasDiagramChange);
    //     if (hasDiagramChange) {
    //         // ถ้ามีการเปลี่ยนแปลง ให้แสดงการแจ้งเตือนก่อน
    //         const userConfirmed = window.confirm("You have unsaved changes. Do you want to leave?");
    //         if (userConfirmed) {
    //             dispatch(setHasDiagramChange(false)); // รีเซ็ตการเปลี่ยนแปลงหลังจากยืนยัน
    //             navigate(newPath); // ไปที่หน้าใหม่
    //         }
    //     } else {
    //         // ถ้าไม่มีการเปลี่ยนแปลงเลย
    //         navigate(newPath);
    //     }
    // };

    useEffect(() => {
        if (currentPage === 'regulatory' && regulatoryFile) {
            setRightSide(true);
            setCurrentFile(regulatoryFile);
            setCurrentFileName(regulatoryFile.regulatory_diagram_name);
            if (dpes && dpes.length === 0) {
                dispatch(setOpenRightSide(false));
                setRightSide(false);
            }
        } else if (currentPage === 'policy') {
            const policyFile = JSON.parse(localStorage.getItem('policy-file'));
            if (policyFile) {
                setRightSide(true);
                setCurrentFile(policyFile);
                setCurrentFileName(policyFile.policy_diagram_name);
            }
        } else {
            setRightSide(false);
            setCurrentFile(null);
            setCurrentFileName(undefined);
        }
    }, [currentPage, regulatoryFile, dpes])

    return (
        <Box sx={{ flexGrow: 1 }}>
            <AppBar
                position="fixed"
                color="white"
                sx={{
                    zIndex: (theme) => theme.zIndex.drawer + 3,
                    bgcolor: 'rgb(255 255 255)',
                }}
            >
                <Toolbar variant="dense" disableGutters>
                    <Box sx={{
                        flexGrow: 1,
                        paddingLeft: 2,
                    }}>
                        <Breadcrumbs aria-label="breadcrumb">
                            <Link
                                underline="hover"
                                key="1"
                                color="inherit"
                                component={Link}
                                to="/editor/workspace"
                            // component="button"
                            // onClick={() => handleRouteChange('/editor/workspace')}
                            >
                                <Typography sx={{ color: 'text.primary', display: 'flex', alignItems: 'center' }} variant='body1'>
                                    <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                                    {project?.project_name}
                                </Typography>
                            </Link>
                            {currentFileName && <Typography variant='body1' color={theme.palette.primary.main}>
                                {currentFileName}
                            </Typography>}
                        </Breadcrumbs>
                    </Box>

                    {rightSide &&
                        <div className='flex flex-row gap-2 mr-3'>
                            {currentPage === 'regulatory' && (
                                <Tooltip title="Simulator" arrow>
                                    <IconButton
                                        size="small"
                                        // hidden={!validDiagram}
                                        disabled={openPreviewDRG || openSimulatorDRG}
                                        onClick={onClickSimulatorIcon}
                                    >

                                        <RocketTwoToneIcon fontSize="inherit" color={openPreviewDRG || openSimulatorDRG ? 'disabled' : 'primary'} />
                                    </IconButton>
                                </Tooltip>
                            )}
                            {currentPage === 'policy' && (
                                <Tooltip title="Simulator" arrow>
                                    <IconButton
                                        size="small"
                                        // hidden={!validDiagram}
                                        disabled={openSimulatorPolicy}
                                        onClick={onClickSimulatorIcon}
                                    >

                                        <RocketTwoToneIcon fontSize="inherit" color={openSimulatorPolicy ? 'disabled' : 'primary'} />
                                    </IconButton>
                                </Tooltip>
                            )}
                            <Tooltip title="Properties" arrow>
                                <IconButton
                                    size="small"
                                    disabled={openPreviewDRG || openSimulatorDRG || openSimulatorPolicy}
                                    onClick={() => onClickOpenRightSide()}
                                >
                                    <ViewSidebarTwoToneIcon fontSize="inherit" color={(openPreviewDRG || openSimulatorDRG || openSimulatorPolicy) ? 'disabled' : 'primary'} />

                                </IconButton>
                            </Tooltip>
                        </div>
                    }

                    <Box
                        sx={rightSide ?
                            {
                                height: "48px",
                                width: drawerWidth,
                                borderLeft: 1,
                                borderColor: '#ccc',
                                display: 'flex',
                                alignItems: 'center',
                                marginRight: 1
                            } : {
                                height: "48px",
                                width: drawerWidth,
                                display: 'flex',
                                alignItems: 'center',
                                marginRight: 1
                            }
                        }
                    >
                        <div className='flex grow justify-center'>
                            <Box
                                sx={{
                                    bgcolor: alpha(theme.palette.primary.main, 0.4),
                                    paddingX: '10px',
                                    paddingY: '4px',
                                    borderRight: 0,
                                    borderTopLeftRadius: 5,
                                    borderBottomLeftRadius: 5,
                                }}
                            >
                                <Tooltip title="OpenID Connect Provider" arrow>
                                    <Typography color={theme.palette.primary.main} variant='subtitle2'>OP</Typography>
                                </Tooltip>
                            </Box>
                            <Box
                                sx={{
                                    bgcolor: alpha(theme.palette.primary.main, 0.15),
                                    paddingX: '10px',
                                    paddingY: '4px',
                                    borderLeft: 0,
                                    borderTopRightRadius: 5,
                                    borderBottomRightRadius: 5
                                }}
                            >
                                <Typography color={theme.palette.primary.main} variant='subtitle2'>{process.env.REACT_APP_OP_HOST}</Typography>
                            </Box>
                        </div>
                        <IconButton
                            className='flex-none'
                            size="medium"
                            aria-label="account of current user"
                            aria-controls="menu-appbar"
                            aria-haspopup="true"
                            onClick={handleMenu}
                            color="primary"
                        >
                            <AccountCircle sx={{ width: 28, height: 28 }} />
                        </IconButton>
                        <Menu
                            id="menu-appbar"
                            anchorEl={anchorEl}
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            open={Boolean(anchorEl)}
                            onClose={handleClose}
                            MenuListProps={{ disablePadding: true }}
                        >
                            <ProfileCard setAnchorEl={setAnchorEl} />
                        </Menu>
                    </Box>
                </Toolbar>
            </AppBar>
        </Box>
    )
}

export default WorkspaceToolBar